import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { ConfigService } from "../config.service";
import { PollsService } from "../polls/polls.service";

@Injectable()
export class PollResponsesService {
  private serviceUrl = ConfigService.serviceUrl;

  constructor(private http: Http) {}

  private extractData(res: Response) {
    let body = res.json();
    return body;
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || "";
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

  getCurrentPoll(): any {
    return PollsService.currentPoll;
  }

  getPollResponses(id: any): Observable<any[]> {
    return this.http
      .get(`${this.serviceUrl}/polls/${id}/responses`)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getPollResponsesCount(id: any): Observable<number> {
    return this.http
      .get(`${this.serviceUrl}/polls/${id}/responses`)
      .map((res) => {
        return this.extractData(res).length;
      })
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pollresponses/pollresponses.service.ts